import { isSsr } from '@/utilities/Utilities';

export interface MetaAttributes {
  [key: string]: string;
}
export interface UtilityState {
  fonts: string[];
  bodyClassList: string[];
  userAgent: string | null;
  host: string | null;
  path: string | null;
  cookies: string | null;
  windowHeight: number | null;
  campaignPadding: number | null;
  currentUrl: string | null;
  initialUrlHash: string | null;
  metatags: MetaAttributes[];
}

export const state = (): UtilityState => {
  let currentUrl;
  let initialUrlHash;
  if (isSsr()) {
    currentUrl = null;
    initialUrlHash = null;
  } else {
    currentUrl = (window.location.href + '').split('#')[0];
    initialUrlHash = window.location.hash;
  }

  return {
    fonts: [],
    bodyClassList: [],
    userAgent: null,
    host: null,
    path: null,
    cookies: null,
    windowHeight: null,
    campaignPadding: 0,
    currentUrl,
    initialUrlHash,
    metatags: []
  };
};
